import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Csv"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6.75L19.5 16.5L18 6.75H16.5L18.387 17.25H20.613L22.5 6.75H21ZM13.5 17.25H9V15.75H13.5V12.75H10.5C9.67192 12.7492 9.00083 12.0781 9 11.25V8.25C9.00083 7.42192 9.67192 6.75083 10.5 6.75H15V8.25H10.5V11.25H13.5C14.3281 11.2508 14.9992 11.9219 15 12.75V15.75C14.9992 16.5781 14.3281 17.2492 13.5 17.25ZM7.5 17.25H3C2.17192 17.2492 1.50083 16.5781 1.5 15.75V8.25C1.50083 7.42192 2.17192 6.75083 3 6.75H7.5V8.25H3V15.75H7.5V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Csv.vue"]]);
